module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('mt-cell-group', {
    attrs: {
      "title": "文本颜色:"
    }
  }, [_c('mt-text', [_vm._v("默认文本(grey)")]), _vm._v(" "), _c('mt-text', {
    attrs: {
      "type": "grey-lv7"
    }
  }, [_vm._v("grey-lv7")]), _vm._v(" "), _c('mt-text', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("primary文本")]), _vm._v(" "), _c('mt-text', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("warning文本")]), _vm._v(" "), _c('mt-text', {
    attrs: {
      "type": "danger"
    }
  }, [_vm._v("danger文本")]), _vm._v(" "), _c('mt-text', {
    attrs: {
      "type": "white"
    }
  }, [_vm._v("white文本")]), _vm._v(" "), _c('mt-text', {
    attrs: {
      "type": "red"
    }
  }, [_vm._v("red文本")]), _vm._v(" "), _c('mt-text', {
    attrs: {
      "type": "orange"
    }
  }, [_vm._v("orange文本")]), _vm._v(" "), _c('mt-text', {
    attrs: {
      "type": "yellow"
    }
  }, [_vm._v("yellow文本")]), _vm._v(" "), _c('mt-text', {
    attrs: {
      "type": "green"
    }
  }, [_vm._v("green文本")]), _vm._v(" "), _c('mt-text', {
    attrs: {
      "type": "blue"
    }
  }, [_vm._v("blue文本")]), _vm._v(" "), _c('mt-text', {
    attrs: {
      "type": "indigo"
    }
  }, [_vm._v("indigo文本")]), _vm._v(" "), _c('mt-text', {
    attrs: {
      "type": "purple"
    }
  }, [_vm._v("purple文本")])], 1), _vm._v(" "), _c('mt-cell-group', {
    attrs: {
      "title": "字体大小:"
    }
  }, [_c('mt-text', {
    attrs: {
      "size": "20px"
    }
  }, [_vm._v("20px")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29659e80","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/pages/text.vue
// module id = 635
// module chunks = 0